var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"flèche_droite","d":"M0,0 l30,45 l-30,45","fill":"none","stroke":"#fff","strokeWidth":"2"}));
}

RightArrow.defaultProps = {"width":"30","height":"90","viewBox":"0 0 30 90"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
